export enum FooterColorEnum {
  primary = 'primary',
  secondary = 'secondary',
}
